import Vue from 'vue'
import Antd from 'ant-design-vue'
import "./ant-design-theme.less"
Vue.use(Antd)
